import * as Common from '@/tenant/common';

export class StockTaking extends Common.StateObject{
  constructor(){
    super('StockTaking');
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
    this.workflowCode="stockTaking";
    this.state = StockTakingStatus.PostWaiting;
    this.workflowStateId = StockTakingStatus.PostWaiting;
  }
  public get actionTooltip() {
    if (this.state == StockTakingStatus.PostWaiting)　return '在庫に反映させる場合は【確定】をクリックします。';
    // else if (this.state == StockTakingStatus.InspectionWaiting) return '内容を編集する場合は、一覧のワークフロー欄で【確定取消】をします。';         
    else if (this.state == StockTakingStatus.Completed) return '内容を修正する場合は【確定取消】をクリックします。';     
    else return '';
  }  
  public stockTakingNo: string = '';
  public pic: string = null;
  public refNo: string = '';
  public bookDate: Date = new Date().getCalendarDate();
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public warehouseOutId: number = 0;
  public warehouseOut: Common.Counterpart = null;
  public description: string = '';
  public barcodeInspection :boolean = false;
}

export enum StockTakingStatus
{
  PostWaiting = 1, // 確定待ち
  InspectionWaiting = 2, // 検品待ち
  Completed = 4 // 完了
}

export class StockTakingQuery extends Common.LoadQuery {
  constructor(){
    super('StockTakingQuery',StockTaking);
    this.sort = 'stockTakingNo';
  }
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public pic: string = "";
  public stockTakingNo: string = "";
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.StockTakingStatus = Common.StockTakingStatus.PostWaiting;
  public holder: string = "";
}

export class GetStockTakingItemQuery extends Common.Query{
  constructor(){
    super('GetStockTakingItemQuery', new Common.ModelBinder(Common.StockTakingItem, true));
  }
  public stockTakingNo: string = '';
}